import { render, staticRenderFns } from "./myRelievPreservation.vue?vue&type=template&id=5a2be6bc&"
import script from "./myRelievPreservation.vue?vue&type=script&lang=js&"
export * from "./myRelievPreservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports